import React from 'react';
import {
  SecondaryNavContainer,
  SecondaryNavLinks,
  SecondaryNavSubTitle,
} from '../../../components/SecondaryNav';
import useShowAdminSettings from '../../../utils/permissions/useShowAdminSettings';
import { adminSettingsLinks, personalSettingsLinks } from './utils';

const SettingsNav = () => {
  const showAdminSettings = useShowAdminSettings();

  return (
    <SecondaryNavContainer heading={'Settings'}>
      <SecondaryNavSubTitle subTitle={'Personal'} />
      <SecondaryNavLinks links={personalSettingsLinks} />
      {showAdminSettings && (
        <>
          <SecondaryNavSubTitle subTitle={'Admin'} />
          <SecondaryNavLinks links={adminSettingsLinks} />
        </>
      )}
    </SecondaryNavContainer>
  );
};

export default SettingsNav;
